import { LogLevel } from '@azure/msal-browser'

const tenantId = import.meta.env.VITE_ENTRA_TENANT_ID
const clientId = import.meta.env.VITE_ENTRA_SPA_CLIENT_ID
const apiClientId = import.meta.env.VITE_ENTRA_API_CLIENT_ID
const redirectUri = import.meta.env.VITE_ENTRA_REDIRECT_URI || window.location.origin

if (!tenantId || !clientId || !apiClientId) {
  throw new Error(
    'Missing Entra configuration. Set VITE_ENTRA_TENANT_ID, VITE_ENTRA_SPA_CLIENT_ID, and VITE_ENTRA_API_CLIENT_ID.',
  )
}

export const msalConfig = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri,
  },
  cache: {
    cacheLocation: 'sessionStorage',
  },
  system: {
    loggerOptions: {
      loggerCallback: (_level: LogLevel, _message: string) => {},
      piiLoggingEnabled: false,
    },
  },
}

export const loginRequest = {
  scopes: ['openid', 'profile', 'email'],
}

export const apiTokenRequest = {
  scopes: [`api://${apiClientId}/access_as_user`],
}

